import anime from "animejs/lib/anime.es.js";

export const resetAnimation = () => {};
export const forwardAnimationRight = () => {
  anime({
    targets: ".character",
    keyframes: [
      { translateX: 15 },
      { translateY: -20 },
      { translateX: 30 },
      { translateY: -40 },
      { translateX: 45 },
      { translateY: -20 },
      { translateX: 60 },
      { translateY: 0 },
    ],
    // translateX:[0,90],
    duration: 400,
    easing: "easeOutElastic(1, .8)",
  });
  anime({
    opacity: 0,
    duration: 10,
  });
};

export const shake = () => {
  const xMax = 6;
  anime({
    targets: ".character",
    easing: "easeInOutSine",
    duration: 350,
    translateX: [
      {
        value: xMax * -1,
      },
      {
        value: xMax,
      },
      {
        value: xMax / -2,
      },
      {
        value: xMax / 2,
      },
      {
        value: 0,
      },
    ],
  });
};

export const shakeUp = () => {
  const yMax = 6;
  anime({
    targets: ".character",
    easing: "easeInOutSine",
    duration: 350,
    translateY: [
      {
        value: yMax * -1,
      },
      {
        value: yMax,
      },
      {
        value: yMax / -2,
      },
      {
        value: yMax / 2,
      },
      {
        value: 0,
      },
    ],
  });
};

export const shrink = () => {
  anime({
    targets: ".character",
    easing: "easeOutElastic(1, .8)",
    duration: 600,
    scale: [1, 0.7,1],
  });
};
